import clsx from 'clsx';

type Status = 'active' | 'pending' | 'provisioning' | 'suspended' | 'cancelled' | 'error';

interface StatusBadgeProps {
  status: Status;
}

const statusStyles: Record<Status, string> = {
  active: 'bg-green-100 text-green-800',
  pending: 'bg-yellow-100 text-yellow-800',
  provisioning: 'bg-blue-100 text-blue-800',
  suspended: 'bg-orange-100 text-orange-800',
  cancelled: 'bg-gray-100 text-gray-800',
  error: 'bg-red-100 text-red-800',
};

export function StatusBadge({ status }: StatusBadgeProps) {
  return (
    <span
      className={clsx(
        'inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium',
        statusStyles[status] || 'bg-gray-100 text-gray-800'
      )}
    >
      {status}
    </span>
  );
}
